import {FilterDto, FilterGroupItemsDto} from "./generated";
import _uniq from "lodash-es/uniq";

export const getSubfilters = function (filterGroupItems: FilterGroupItemsDto, filterId: number): FilterDto[] {
    // search for id in groups and items
    const filter = filterGroupItems.groups.find(group => group.id == filterId) ||
        filterGroupItems.items.find(item => item.id == filterId);
    if (filter) {
        function recurse(parentId: number, items: FilterDto[]) {
            filterGroupItems.items
                .filter(item => item.visible)
                .filter(item =>
                    item.dependency.indexOf(parentId.toString()) > -1)
                .forEach(item => {
                    items.push(item);
                    recurse(item.id, items);
                });
        }

        const items = <FilterDto[]>[];
        recurse(filterId, items);
        return _uniq(items).sort((f1, f2) => f1.order - f2.order);

    } else {
        throw Error('filter not found');
    }
};
